<div
  class="modal fail-dialog-backdrop"
  style="display: block !important; background: #0000007a"
  id="content"
>
  <div class="modal-dialog fail-dialog">
    <div class="modal-content fail-dialog-content">
      <div class="fail-dialog-body">
        <div class="fail-dialog-icon">
          <img alt="" src="/assets/images/fry-bucket.svg" />
        </div>

        <h4 class="fail-dialog-title">{{ title }}</h4>

        <p class="fail-dialog-message">{{ errorMessage }}</p>
      </div>

      <div class="fail-dialog-footer">
        <button
          type="button"
          class="fail-btn fail-btn-ok"
          (click)="onRedirectAndClose()"
        >
          OK
        </button>
      </div>
    </div>
  </div>
</div>
